import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from './styles';
import { selectCurrentUser } from '../../../../../store/modules/users/selectors';

const PricingPageTitle = () => {
  const classes = useStyles();
  const { data: user } = useSelector(selectCurrentUser);

  return (
    <div className={classes.titleContainer}>
      <h1 className={classes.title}>{user ? 'Choose your plan' : 'Pricing'}</h1>
      {!user && (
        <p className={classes.description}>
          Produce like a pro and connect
          <br />
          {' '}
          with your customers like never before
        </p>
      )}
    </div>
  );
};

export default PricingPageTitle;
